import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import {
  AlliedBrokerPageStore,
  AlliedBrokerPageStoreContext,
} from 'store/pages/enrollment/broker/broker-allied/pageStore';
import PageContent from 'components/enrollment/broker/broker-allied';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const AlliedBrokerPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new AlliedBrokerPageStore({ groupId, periodId }), [groupId, periodId]);

  return (
    <ProposalStatusLayout>
      <AlliedBrokerPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </AlliedBrokerPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default AlliedBrokerPage;
